/* Product-specific review rotation. No fetch, tracking, storage or commerce writes. */
(function () {
  const INTERVAL = 9000;
  if (typeof module !== 'undefined') module.exports = { INTERVAL };
  if (typeof window === 'undefined' || customElements.get('cx-review-carousel')) return;
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      if (this.slides.length < 2 || this.abort) return;
      this.index = 0; this.inView = false; this.hovered = false; this.focused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.abort = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
      on(this.querySelector('[data-review-next]'), 'click', () => this.move(1, true));
      on(this.querySelector('[data-review-prev]'), 'click', () => this.move(-1, true));
      on(this.querySelector('[data-review-expand]'), 'click', () => {
        this.paused = true; this.toggleAttribute('data-expanded'); this.updateExpansion(); this.sync();
      });
      on(this, 'pointerenter', () => { this.hovered = true; this.sync(); });
      on(this, 'pointerleave', () => { this.hovered = false; this.sync(); });
      // No transport icon: any deliberate interaction stops rotation for this visit.
      on(this, 'pointerdown', () => { this.paused = true; this.sync(); });
      on(this, 'focusin', () => { this.focused = true; this.paused = true; this.sync(); });
      on(this, 'focusout', e => { this.focused = this.contains(e.relatedTarget); this.sync(); });
      on(document, 'visibilitychange', () => this.sync());
      on(this.reduced, 'change', () => { if (this.reduced.matches) this.paused = true; this.sync(); });
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5; this.sync(); }, { threshold: 0.5 });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => this.updateExpansion()); this.resize.observe(this);
      this.setAttribute('data-enhanced', '');
      this.querySelector('.cx-review-controls').hidden = false;
      this.updateExpansion(); this.sync();
    }
    updateExpansion() {
      const quote = this.slides[this.index].querySelector('blockquote');
      const expanded = this.hasAttribute('data-expanded');
      const clipped = expanded || quote.scrollHeight > quote.clientHeight + 1;
      const control = this.querySelector('[data-review-expand]');
      control.hidden = !clipped;
      control.textContent = expanded ? this.dataset.collapse : this.dataset.expand;
      control.setAttribute('aria-expanded', String(expanded));
      this.querySelector('[data-all-reviews]').hidden = clipped;
    }
    move(delta, manual) {
      if (manual) this.paused = true;
      this.removeAttribute('data-expanded');
      this.index = (this.index + delta + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-review-count]').textContent = `${this.index + 1}/${this.slides.length}`;
      this.updateExpansion(); this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const running = !this.paused && !this.reduced.matches;
      this.toggleAttribute('data-reduced-motion', this.reduced.matches);
      // No live region while auto-rotating: avoid unsolicited screen-reader announcements.
      this.setAttribute('aria-live', 'off');
      if (running && this.inView && !this.hovered && !this.focused && !document.hidden && !this.hasAttribute('data-expanded')) {
        this.timer = setTimeout(() => this.move(1, false), INTERVAL);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer); this.observer?.disconnect(); this.resize?.disconnect();
      this.abort?.abort(); this.abort = null;
    }
  }
  customElements.define('cx-review-carousel', ReviewCarousel);
})();
